export default function checkboxService() {
  return function generate(viewField, engineApi) {
    viewField.metadata = viewField.metadata || {};
    const { trueValue, falseValue } = getCheckboxValues(viewField);
    const elem = engineApi.field
      .setCommonAttributes('ec-checkbox', viewField, engineApi)
      .addAttribute('true-value', trueValue, true)
      .addAttribute('false-value', falseValue, true)
      .addAttribute('text', viewField.metadata.text || '');

    if (viewField.metadata.noEllipsis) {
      elem.addAttribute('no-ellipsis', '');
    }

    return elem;
  };
}

function getCheckboxValues(viewField) {
  if (viewField.metadata && viewField.metadata.true) {
    return {
      trueValue: viewField.metadata.true,
      falseValue: viewField.metadata.false || '',
    };
  }
  if (viewField.metadata && viewField.metadata.select && viewField.metadata.select.true) {
    return {
      trueValue: viewField.metadata.select.true,
      falseValue: viewField.metadata.select.false || '',
    };
  }
  return { trueValue: '', falseValue: '' };
}
